export default __webpack_public_path__ + "static/media/prize_10pcs_kcw.74077a2c.png";